import Vue from 'vue';
import store from './../../store';
import orderTransformer from './../../transformers/productFlowOrder';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const orders = orderTransformer.fetchCollection(data.data);
  store.dispatch('fetchproductFlowOrders', orders);
  resolve({ orders });
};

const failed = (error, reject) => reject(error);


export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/productflow/list/orders', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productFlow/orders.js